module.exports = __webpack_public_path__ + "img/icon-ywqn-banner-1.60203050.png";